export default __webpack_public_path__ + "static/media/bootstraping.74ca0347.svg";